import React from 'react'
import ToggleSwitch from './ToggleSwitch'

class Venues extends React.Component {
  constructor(props) {
    super(props);

    // states for map layers
    this.state = {

        venues: [

          {
            id: "club",
            name: "Club",
            checked: true,
            number_of_venues: this.props.dataFromParent.features.filter((obj) => obj.properties.venue_type === "Club" ).length
          }
        ],
        venues_2: [
          {
            id: "all_venues_2",
            name: "Live-Musikspielstätten",
            checked: true,
            number_of_venues: this.props.dataFromParent.features.filter((obj) => obj.properties.venue_type === "Music Bar" || obj.properties.venue_type === "Dance/Ballroom" || obj.properties.venue_type === "Disco" || obj.properties.venue_type === "Outdoor stage").length

          },
          {
            id: "dance_ballroom",
            name: "Dance/Ballroom",
            checked: true,
            height:10,
            handleDiameter:8
          },
          {
            id: "music_bar",
            name: "Music Bar",
            checked: true,
            height:10,
            handleDiameter:8
          },
          {
            id: "disco",
            name: "Disco",
            checked: true,
            height:10,
            handleDiameter:8
          },
          {
            id: "outdoor_stage",
            name: "Outdoor stage",
            checked: true,
            height:10,
            handleDiameter:8
        },
        ],
        venues_3: [
          {
            id: "all_venues_3",
            name: "Musikspielstätten",
            checked: true,
             number_of_venues: this.props.dataFromParent.features.filter((obj) => obj.properties.venue_type === "Gallery" || obj.properties.venue_type === "Sociocultural Center" ||  obj.properties.venue_type === "Rental venue/warehouse"|| obj.properties.venue_type === "Restaurant/Cafe" || obj.properties.venue_type === "Theater" 
              || obj.properties.venue_type === "Arena/Stadium" || obj.properties.venue_type === "Concert Hall/Livehouse"|| obj.properties.venue_type === "Cinema" || obj.properties.venue_type === "Production Studio/CoWorking" || obj.properties.venue_type === "Retail Store/Shop").length
          },
          {
            id: "gallery",
            name: "Gallery",
            checked: true,
            height:10,
            handleDiameter:8
        },
        {
            id: "sc_center",
            name: "Sociocultural Center",
            checked: true,
            height:10,
            handleDiameter:8
        },

        {
            id: "arena_stadium",
            name: "Arena/Stadium",
            checked: true,
            height:10,
            handleDiameter:8
        },
        {
            id: "concert_hall",
            name: "Concert Hall/Livehouse",
            checked: true,
            height:10,
            handleDiameter:8
        },
        {
            id: "cinema",
            name: "Cinema",
            checked: true,
            height:10,
            handleDiameter:8
        },
        {
            id: "prod_studio",
            name: "Production Studio/CoWorking",
            checked: true,
            height:10,
            shandleDiameter:8
        },
        {
            id: "retail_store",
            name: "Retail Store/Shop",
            checked: true,
            height:10,
            handleDiameter:8
        },
        {
            id: "rental_venue",
            name: "Rental venue/warehouse",
            checked: true,
            height:10,
            handleDiameter:8
        },
        {
            id: "cafe",
            name: "Restaurant/Cafe",
            checked: true,
            height:10,
            handleDiameter:8
        },
        {
            id: "theater",
            name: "Theater",
            checked: true,
            height:10,
            handleDiameter:8
        }

        ]


  };


    // send layers to map data
    this.props.setVenues(this.state);   

  }

  onToggleLayerStatus = (toggledLayer) => {

    const layers  = this.state.venues;
    const venues_2  = this.state.venues_2;
    const venues_3  = this.state.venues_3;

    const nextVenueState = layers.map(layer => {

      if (toggledLayer.layerId === 'all_venues'){

         // onToggleLayerStatus(bezirk)
          return {
          ...layer,
          checked: toggledLayer.checked
        };

      }else{
        if (toggledLayer.layerId !== layer.id) return layer;
      else {
        return {
          ...layer,
          checked: toggledLayer.checked
        };
      }
      }

    });

    const nextCat2State = venues_2.map(layer => {

     if (toggledLayer.layerId === 'all_venues_2'){

         // onToggleLayerStatus(bezirk)
          return {
          ...layer,
          checked: toggledLayer.checked
        };

      }else{
        if (toggledLayer.layerId !== layer.id) return layer;
      else {
        return {
          ...layer,
          checked: toggledLayer.checked
        };
      }
      }
    });

     const nextCat3State = venues_3.map(layer => {


     if (toggledLayer.layerId === 'all_venues_3'){

         // onToggleLayerStatus(bezirk)
          return {
          ...layer,
          checked: toggledLayer.checked
        };

      }else{
        if (toggledLayer.layerId !== layer.id) return layer;
      else {
        return {
          ...layer,
          checked: toggledLayer.checked
        };
      }
      }
    });
    // update layer states and map data
    this.setState(prevState => ({ venues: nextVenueState, venues_2:nextCat2State ,venues_3:nextCat3State}), () => {
      this.props.setVenues(this.state);
    });

  }

  render() {
    const venues  = this.state.venues;
    const venues_2  = this.state.venues_2;
    const venues_3  = this.state.venues_3;


    return (
      <div>
        <h4>Venues</h4>
        {venues.map(venue => (
          <ToggleSwitch
            key={venue.id}
            name={venue.name +" ("+venue.number_of_venues +")"}
            layerId={venue.id}
            height={venue.height}
            handleDiameter={venue.handleDiameter}
            checked={venue.checked}
            onToggleLayer={this.onToggleLayerStatus}
          />
        ))}


        {/* Master toggle for Live-Musikspielstätten */}
          <ToggleSwitch
            key={venues_2[0].id}
            name={venues_2[0].name +" ("+venues_2[0].number_of_venues +")"}
            layerId={venues_2[0].id}
            height={venues_2[0].height}
            handleDiameter={venues_2[0].handleDiameter}
            checked={venues_2[0].checked}
            onToggleLayer={this.onToggleLayerStatus}
          />

          {/* Master toggle for Musikspielstätten */}
          <ToggleSwitch
            key={venues_3[0].id}
            name={venues_3[0].name +" ("+venues_3[0].number_of_venues +")"}
            layerId={venues_3[0].id}
            height={venues_3[0].height}
            handleDiameter={venues_3[0].handleDiameter}
            checked={venues_3[0].checked}
            onToggleLayer={this.onToggleLayerStatus}
          />
        
      </div>

    );
  }
}

export default Venues
